"use client"

import TablaRrhhFichajesComponent from "./TablaRrhhFichajesComponent.js"

const RrhhFichajesComponent = () => {
  return <TablaRrhhFichajesComponent />
}

export default RrhhFichajesComponent
